import { Absent_getInstance1my5kmv368g0i as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.m6o_1 = partyId;
        this.n6o_1 = playerId;
        this.o6o_1 = name;
        this.p6o_1 = email;
        this.q6o_1 = badge;
        this.r6o_1 = callSignAdjective;
        this.s6o_1 = callSignNoun;
        this.t6o_1 = imageURL;
        this.u6o_1 = avatarType;
        this.v6o_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.m6o_1.toString() + ', playerId=' + this.n6o_1.toString() + ', name=' + this.o6o_1 + ', email=' + this.p6o_1 + ', badge=' + this.q6o_1.toString() + ', callSignAdjective=' + this.r6o_1 + ', callSignNoun=' + this.s6o_1 + ', imageURL=' + toString(this.t6o_1) + ', avatarType=' + toString(this.u6o_1) + ', unvalidatedEmails=' + toString(this.v6o_1) + ')';
      }
      hashCode() {
        var result = this.m6o_1.hashCode();
        result = imul(result, 31) + this.n6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.o6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p6o_1) | 0;
        result = imul(result, 31) + this.q6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.r6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s6o_1) | 0;
        result = imul(result, 31) + hashCode(this.t6o_1) | 0;
        result = imul(result, 31) + hashCode(this.u6o_1) | 0;
        result = imul(result, 31) + hashCode(this.v6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.m6o_1.equals(other.m6o_1))
          return false;
        if (!this.n6o_1.equals(other.n6o_1))
          return false;
        if (!(this.o6o_1 === other.o6o_1))
          return false;
        if (!(this.p6o_1 === other.p6o_1))
          return false;
        if (!this.q6o_1.equals(other.q6o_1))
          return false;
        if (!(this.r6o_1 === other.r6o_1))
          return false;
        if (!(this.s6o_1 === other.s6o_1))
          return false;
        if (!equals(this.t6o_1, other.t6o_1))
          return false;
        if (!equals(this.u6o_1, other.u6o_1))
          return false;
        if (!equals(this.v6o_1, other.v6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
